module.exports = __webpack_public_path__ + "img/voortuin a v solmsstr voor.19b07f38.jpg";